import React from 'react'
import { IconAddImg, IconMail, IconAnalitic, IconReport, IconPodcast } from 'components/SvgIcons/'

export const adminMenu = [
  {
    iconMenu: props => <IconAddImg {...props} />, title: 'Add illustrations', label: 'illustrations', id: '1',
  },
  {
    iconMenu: props => <IconMail {...props} />, title: 'Mailings', label: 'mailings', id: '2',
  },
  {
    iconMenu: props => <IconAnalitic {...props} />, title: 'Analytics', label: 'analytics', id: '3',
  },
  {
    iconMenu: props => <IconReport {...props} />, title: 'Reported users', label: 'reported', id: '4',
  },
  {
    iconMenu: props => <IconPodcast {...props} />, title: 'Podcasts', label: 'podcasts', id: '5',
  },
]
